import React, { useContext } from 'react';
import { Progress } from 'antd';
import { getSafePercentage } from '../../utils/misc';
import { ThemeContext, ThemeContextState } from '../../context/ThemeContext';
import { BASIC_STATS_PROGRESS_COLORS } from '../../config/colors';
import styles from './BasicProgressStats.module.css';

export interface BasicProgressStatsProps {
  problemsSolved: number
  totalProblems: number
  problemSetsCompleted: number
  totalProblemSets: number
};

// shows progress bars that indicate
// number of problems solved by user
// and number of problem sets completed by user
const BasicProgressStats = (props: BasicProgressStatsProps): JSX.Element | null => {
  // get current theme from theme context
  const { theme } = useContext(ThemeContext) as ThemeContextState;

  return (
    <div className={styles.mainContainer}>
      <Progress
        type='dashboard'
        percent={getSafePercentage(props.problemsSolved, props.totalProblems)}
        strokeColor={{'0%': BASIC_STATS_PROGRESS_COLORS['problems_solved'].left, '100%': BASIC_STATS_PROGRESS_COLORS['problems_solved'].right}}
        trailColor={BASIC_STATS_PROGRESS_COLORS['problems_solved'].unfilled[theme]}
        format={() => (
          <div
            className={styles.dashboardProgressText}
          >
            <strong>
              {`${props.problemsSolved}/${props.totalProblems}`}
            </strong>
            <br />
            Problems Solved
          </div>
        )}
      />
      <Progress
        type='dashboard'
        percent={getSafePercentage(props.problemSetsCompleted, props.totalProblemSets)}
        strokeColor={{'0%': BASIC_STATS_PROGRESS_COLORS['problems_sets_completed'].left, '100%': BASIC_STATS_PROGRESS_COLORS['problems_sets_completed'].right}}
        trailColor={BASIC_STATS_PROGRESS_COLORS['problems_sets_completed'].unfilled[theme]}
        format={() => (
          <div
            className={styles.dashboardProgressText}
          >
            <strong>
              {`${props.problemSetsCompleted}/${props.totalProblemSets}`}
            </strong>
            <br />
            Problem Sets Completed
          </div>
        )}
      />
    </div>
  );
};

export default BasicProgressStats;
